import BaseService from "../base";
import {keycloak} from "../../keycloak/keycloak";

const apiService = new BaseService(process.env.REACT_APP_VISUALS_API_URL + '/analytics', {});

export async function fetchSalesAnalytics() {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get('/v1/sales', null, {headers: headers})
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}


export async function fetchFinancialAnalytics() {
    if (keycloak.authenticated) {
        let headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`,
            'Accept': 'application/json'
        }
        return await apiService.get('/v1/financial', null, {headers: headers})
            .then(result => {
                return result.data
            })
            .catch(reason => {
                throw reason
            })
    }
    throw new Error('You are not authenticated')
}


